import CheckingLayout from '@src/routes/_authenticated/dashboard/checking/-checking-layout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/checking/')({
  component: CheckingLayout,
});
